export const plaidAccountTypes = {
  isCreditOrLoanAccounts: (type) => ['credit', 'loan'].includes(type),
  isCreditCard: (subType) => subType === 'credit card',
  isCashAccount: (subType) => subType === 'checking',
};

export const isLiability = (account) => plaidAccountTypes.isCreditOrLoanAccounts(account.accountType || account.type);
export const isCreditCard = (account) => plaidAccountTypes.isCreditCard(account.accountSubType || account.subtype);
export const isCashAccount = (account) => plaidAccountTypes.isCashAccount(account.accountSubType || account.subtype);
export const isOtherAccount = (account) => account.type === 'other' && (account.accountSubType === 'other' || account.subtype === 'other');